<template>
    <div class="text-uppercase font-size-sm">
        <div class="d-none d-xl-block">
            <badge v-if="subscription.status === 'active'" type="badge-success">
                {{ __('general.active') }}
            </badge>
            <badge v-else type="badge-secondary">
                {{ subscription.status }}
            </badge>
        </div>
        <div class="d-block d-xl-none">
            <Dot v-if="subscription.status === 'active'" type="success"/>
            <Dot v-else type="secondary"/>
        </div>
    </div>
</template>

<script>
import Dot from "../Dot.vue";
import Badge from "../Badge.vue";

export default {
    components: {Badge, Dot},

    props: {
        subscription: Object
    }
}
</script>
